export default function ScoreBar({ score }) {
  const pct = Math.abs(score) * 50;
  const isPos = score >= 0;
  const label = score > 0 ? `+${score.toFixed(2)}` : score.toFixed(2);
  const fill  = score > 0.2 ? 'bg-green-500' : score < -0.2 ? 'bg-red-500' : 'bg-slate-400';
  const text  = score > 0.2 ? 'text-green-400' : score < -0.2 ? 'text-red-400' : 'text-slate-400';

  return (
    <div className="flex items-center gap-2">
      <div className="relative w-28 h-2 bg-slate-900 rounded-full overflow-hidden flex-shrink-0">
        <div className="absolute left-1/2 top-0 w-px h-full bg-slate-600" />
        <div
          className={`absolute top-0 h-full rounded-full ${fill}`}
          style={{ left: isPos ? '50%' : `${50 - pct}%`, width: `${pct}%` }}
        />
      </div>
      <span className={`text-xs font-semibold tabular-nums w-9 ${text}`}>{label}</span>
    </div>
  );
}
